import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {
    ActionCardImage,
    GraphicalActionCard,
    LinkWithAttribution,
} from '../../../../../../components';

export function Type2DiabetesWeight(props) {
    const {currentStep, totalSteps} = props;

    const intl = useIntl();

    return (
        <GraphicalActionCard
            currentStep={currentStep}
            dataTestId={'weight-T2D'}
            headerImage={ActionCardImage.WEIGHT}
            title={intl.formatMessage({id: 'reports.trait.lifestyleActions.weight.title'})}
            totalSteps={totalSteps}
        >
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.description.one.T2D'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.description.two.T2D'} />
            </p>
            <p>
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.description.three'} />
            </p>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.CDCP'})}
                url={'https://www.cdc.gov/healthyweight/losing_weight/getting_started.html'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.link.lose'} />
            </LinkWithAttribution>
            <LinkWithAttribution
                attribution={intl.formatMessage({id: 'common.link.attribution.CDCP'})}
                url={'https://www.cdc.gov/healthyweight/prevention/index.html'}
            >
                <FormattedMessage id={'reports.trait.lifestyleActions.weight.link.prevent'} />
            </LinkWithAttribution>
        </GraphicalActionCard>
    );
}
